export enum EBannerType {
  WEB = 'WEB',
  APP = 'APP',
  WEB_APP = 'WEB_APP',
}

export enum EBannerStatus {
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

export interface IBanner {
  _id: string
  photo: string
  video: string | null // если задано — фоном баннера идёт видео вместо photo
  video_desktop?: string | null // версия video в 1920×1080 для сайта на экранах от 1024 px; нет — там тоже video
  video_loop?: boolean
  position: number
  fixed_position?: boolean // «Не перемешивать»: баннер главной не участвует в ротации
  type: EBannerType
  status: EBannerStatus
  seller_id?: string
  page_id?: string | null
  navigation_path: string | null
  navigation_params: Record<string, any> | null
  webUrl: string | null
  scrollDown: boolean // web: клик по баннеру листает страницу вниз вместо перехода по webUrl
  end_date?: string | null // «Дата окончания»: после неё баннер уходит в архив
  createdAt: string
  updatedAt: string
}

export interface ICreateBanner {
  photo?: File
  video?: File
  position: number
  type?: EBannerType
  video_loop?: boolean
  seller_id?: string
  page_id?: string
  navigation_path?: string
  navigation_params?: Record<string, any>
  webUrl?: string
  scrollDown?: boolean
}
